const regexp = /order_id=(\d+)/;

export default () => {
    const url = window.location.href;
    if (regexp.test(url)) {
        return url.match(regexp)[1];
    }
};



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/orderIdFromUrlService.js